import { Typography } from "@mui/material"
import { ReactNode } from "react"

type Props = {
    isStrikeThrough?: boolean
    children: ReactNode
}

export function TooltipPriceTypography(props: Props) {
    const { isStrikeThrough, children } = props
    return (
        <Typography
            variant="label"
            color="#FFFFFF"
            sx={{
                textDecoration: isStrikeThrough ? "line-through" : "none",
                opacity: 1,
            }}
        >
            {children}
        </Typography>
    )
}
